(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = exports.styles = ".image-card {\n  display: block;\n  font-size: 0;\n  white-space: nowrap; }\n  .image-card:link, .image-card:visited, .image-card:hover, .image-card:focus, .image-card:active {\n    color: #231f20;\n    text-decoration: none; }\n\n.image-card--responsive {\n  white-space: normal; }\n\n.image-card--border {\n  border: 10px solid #ebebeb; }\n\n.image-card__img-wrapper {\n  display: inline-block;\n  font-size: 1rem;\n  vertical-align: middle;\n  width: 33%; }\n\n.image-card__img-wrapper--xs {\n  width: 88px; }\n\n.image-card--responsive .image-card__img-wrapper {\n  width: 100%; }\n  @media screen and (min-width: 744px) {\n    .image-card--responsive .image-card__img-wrapper {\n      width: 33%; } }\n\n.image-card__img-wrapper-inner {\n  position: relative;\n  height: 0;\n  padding-bottom: 60%; }\n\n.image-card__img-wrapper-inner--4x3 {\n  padding-bottom: 75%; }\n\n.image-card__img-wrapper-inner--highlighted {\n  background-color: #ffffff;\n  border: 1px solid #ebebeb; }\n\n.image-card__img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block; }\n\n.image-card__text {\n  display: inline-block;\n  font-size: 1rem;\n  vertical-align: middle;\n  white-space: normal;\n  width: 67%;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding-left: 5%;\n  padding-right: 5%; }\n\n.image-card__text--xs {\n  width: calc(100% - 88px); }\n\n.image-card__text--top {\n  vertical-align: top; }\n\n.image-card__text--left {\n  padding-left: 0; }\n\n.image-card--responsive .image-card__text {\n  width: 100%; }\n  @media screen and (min-width: 744px) {\n    .image-card--responsive .image-card__text {\n      width: 67%; } }\n\n.image-card__title {\n  color: #5c656e;\n  font-size: 17px;\n  line-height: 1.15;\n  margin: 0; }\n\n.image-card__sub {\n  border-top: 1px solid #f5f5f5;\n  color: #5c656e;\n  display: block;\n  font-size: 0.82353rem;\n  padding-top: 10px;\n  margin-top: 10px; }\n\n.image-card__desc {\n  color: #5c656e;\n  display: block;\n  margin-top: 15px; }\n\n.marketing-block {\n  min-height: 20px;\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 3px; }\n  @media screen and (min-width: 744px) {\n    .marketing-block {\n      padding: 15px; } }\n  @media screen and (min-width: 984px) {\n    .marketing-block {\n      padding: 20px; } }\n  @media screen and (min-width: 1280px) {\n    .marketing-block {\n      padding: 30px; } }\n  .marketing-block--vertical {\n    padding: 0; }\n  .marketing-block--highlighted {\n    background-color: #ffffff; }\n  .marketing-block--bordered {\n    box-shadow: 0 0 0 1px #d2d6d9 inset; }\n  .marketing-block__main {\n    text-align: center;\n    position: relative;\n    padding: 15px 10px 20px; }\n    @media screen and (min-width: 744px) {\n      .marketing-block__main {\n        padding: 0; } }\n  @media screen and (min-width: 744px) {\n    .marketing-block__main--vertical {\n      padding: 15px 10px 20px; } }\n  @media screen and (min-width: 1280px) {\n    .marketing-block__main--vertical {\n      padding-right: 15px;\n      padding-left: 15px; } }\n  .marketing-block__img-wrapper {\n    text-align: center; }\n  .marketing-block__img-wrapper--vertical {\n    width: 100%;\n    height: 144px;\n    overflow: hidden;\n    position: relative;\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px; }\n  .marketing-block__img {\n    max-width: 100%;\n    height: auto; }\n  .marketing-block__img--vertical {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: none;\n    min-width: 100%;\n    min-height: 100%; }\n  .marketing-block__title {\n    font-size: 1.11765rem;\n    font-weight: 700;\n    color: #2f3840;\n    margin-top: 0; }\n    @media screen and (min-width: 744px) {\n      .marketing-block__title {\n        font-size: 1.23529rem; } }\n    @media screen and (min-width: 984px) {\n      .marketing-block__title {\n        font-size: 1.47059rem; } }\n    @media screen and (min-width: 1280px) {\n      .marketing-block__title {\n        font-size: 1.82353rem;\n        margin-bottom: 20px; } }\n  @media screen and (min-width: 984px) {\n    .marketing-block__title--md {\n      font-size: 1.47059rem;\n      margin-bottom: 15px; } }\n  @media screen and (min-width: 984px) {\n    .marketing-block__title--sm {\n      font-size: 22px;\n      margin-bottom: 10px; } }\n  @media screen and (min-width: 744px) {\n    .marketing-block__title--xs {\n      font-size: 1.11765rem;\n      margin-bottom: 10px; } }\n  .marketing-block__desc {\n    font-size: 17px;\n    line-height: 1.26;\n    color: #5c656e;\n    margin-top: 10px;\n    margin-bottom: 20px; }\n    @media screen and (min-width: 984px) {\n      .marketing-block__desc {\n        font-size: 1.11765rem;\n        line-height: 1.24;\n        margin-top: 15px;\n        margin-bottom: 30px; } }\n    @media screen and (min-width: 1280px) {\n      .marketing-block__desc {\n        font-size: 1.23529rem;\n        line-height: 1.1;\n        margin-bottom: 35px; } }\n  @media screen and (min-width: 984px) {\n    .marketing-block__desc--md {\n      font-size: 1.11765rem;\n      line-height: 1.25;\n      margin-bottom: 20px; } }\n  @media screen and (min-width: 984px) {\n    .marketing-block__desc--sm {\n      font-size: 17px;\n      margin-top: 0;\n      margin-bottom: 20px; } }\n  @media screen and (min-width: 984px) {\n    .marketing-block__desc--xs {\n      font-size: 17px;\n      line-height: 1.125;\n      margin-top: 0;\n      margin-bottom: 20px; } }\n  .marketing-block__tag {\n    font-size: 17px;\n    font-style: italic;\n    color: #fd3753;\n    background-color: #ffffff;\n    border-radius: 3px;\n    margin-bottom: 0;\n    padding: 3px 15px;\n    position: absolute;\n    top: -20px;\n    left: 50%;\n    z-index: 2;\n    transform: translateX(-50%); }\n\n.image-card__image-wrapper--shift-up {\n  transform: translateY(-50%);\n  float: right; }\n\n.image-card__text--full-width {\n  width: 100%;\n  display: block; }\n\n.image-card__img-wrapper-inner--no-border {\n  border: 0; }\n\n.rz-list__right {\n  padding-left: 10px;\n  text-align: right;\n  display: table-cell;\n  vertical-align: top;\n  width: 98px; }\n\n.rz-list__left {\n  text-align: left;\n  display: table-cell;\n  vertical-align: middle; }\n\n.rz-highlight-orange {\n  color: #eb612a;\n  font-weight: 700; }\n\n.rz-exclusive-footer {\n  position: relative;\n  display: table;\n  width: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px; }\n  .rz-exclusive-footer:after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: -15px;\n    right: -15px;\n    height: 1px;\n    background-color: #CFDAE5; }\n\n.rz-exclusive-container {\n  border: 1px solid #CFDAE5;\n  background-color: #ffffff; }\n\n.rz-exclusive-container__content {\n  margin-left: 15px;\n  margin-right: 15px;\n  padding-bottom: 2px; }\n\n.rz-container__content {\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding-bottom: 10px; }\n\n.rz-exclusive-banner {\n  margin-bottom: 5px; }\n\n.rz-exclusive-banner__empty {\n  height: 1em; }\n\n.rz-image-card__text {\n  padding-top: 0;\n  padding-bottom: 0;\n  line-height: 1.35;\n  width: calc(100% - 100px); }\n\n.rz-image-card__wrapper-width {\n  width: 100px; }\n\n.rz-item {\n  border-bottom: 1px solid #CFDAE5;\n  padding-bottom: 10px;\n  margin-bottom: 10px; }\n  .rz-item:last-child {\n    margin-bottom: -10px;\n    border: 0;\n    padding-bottom: 0; }\n\n.rz-item--exclusive {\n  border: 0;\n  padding-bottom: 0; }\n\n.rz-item__title {\n  line-height: 17px; }\n\n.rz-item--rating-container {\n  font-size: 0.82353rem; }\n  .rz-item--rating-container:before, .rz-item--rating-container:after {\n    content: \" \";\n    display: table; }\n  .rz-item--rating-container:after {\n    clear: both; }\n\n.rz-item--rating__content {\n  display: inline-block; }\n\n.rz-item--price__content {\n  display: inline-block;\n  float: right; }\n\n.rz-exclusive__heading {\n  font-size: 16px; }\n\n.rz-exclusive__content {\n  white-space: normal;\n  line-height: 1.35; }\n\n.rz-exclusive__content--padding {\n  padding: 0 15px 10px 15px; }\n\n.rz-exclusive__footer {\n  padding: 10px 15px;\n  font-size: 0.82353rem; }\n  .rz-exclusive__footer:before, .rz-exclusive__footer:after {\n    content: \" \";\n    display: table; }\n  .rz-exclusive__footer:after {\n    clear: both; }\n\n.rz-institute-container {\n  background-color: #ffffff;\n  border-radius: 0.3em; }\n\n.rz-institute-img {\n  border-radius: 0.3em 0.3em 0 0; }\n\n.l-pos-center {\n  -ms-transform: translate(-50%, -50%); }\n\n.rz-resource, .rz-news {\n  padding-bottom: 8px;\n  margin-bottom: 8px; }\n  .rz-resource > article, .rz-news > article {\n    margin-bottom: 0; }\n  .rz-resource .image-card__img-wrapper, .rz-news .image-card__img-wrapper {\n    width: 100px; }\n  .rz-resource .image-card__text, .rz-news .image-card__text {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-right: 0;\n    line-height: 1.35;\n    width: calc(100% - 100px); }\n\n.rz-resource .image-card__text {\n  padding-left: 8px;\n  padding-right: 0px; }\n\n.rz-resource .rz-item__title {\n  min-height: 36px; }\n\n.rz-news .image-card__text--left {\n  padding-right: 8px; }\n\n.rz {\n  margin-bottom: 16px; }\n\n.rz-list {\n  padding: 0 16px;\n  background-color: #ffffff; }\n\n.rz__title {\n  background-color: #ffffff;\n  font-weight: bold;\n  font-size: 16px;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 10px 16px; }\n\n.rz__title--mint {\n  background-color: #00C7B1;\n  color: #ffffff; }\n\n.rz__title--pink {\n  background-color: #EF426F;\n  color: #ffffff; }\n\n.rz__text-container {\n  -ms-flex: 1;\n      flex: 1;\n  padding-right: 10px;\n  line-height: 106%; }\n\n.rz-image-container {\n  position: relative;\n  width: 94px;\n  height: 70px;\n  overflow: hidden;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.rz-list__item {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  padding: 8px 0;\n  border-bottom: 1px solid #ebebeb; }\n\n.rz-list__item-title {\n  font-size: 14px;\n  font-weight: bold;\n  margin-top: 0;\n  margin-bottom: 0; }\n\n.rz-list__item-text {\n  font-size: 14px;\n  margin-top: 0;\n  margin-bottom: 0; }\n\n.rz__more-link {\n  display: block;\n  padding: 16px;\n  border-top: 1px solid #ebebeb;\n  margin-top: -1px;\n  font-size: 16px;\n  text-align: center;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #ffffff; }\n\n.l-inline {\n  display: inline; }\n\n.rz-job__img-container {\n  overflow: hidden;\n  position: relative;\n  padding-bottom: 31.3%;\n  background-color: #ffffff; }\n\n.rz-job__body {\n  padding: 8px 16px 14px 16px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #ebebeb; }\n\n.rz-job__feature {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  padding: 16px 0; }\n\n.rz-job__feature-title {\n  font-weight: bold;\n  font-size: 20px;\n  margin-top: 0;\n  margin-bottom: 0;\n  letter-spacing: -0.035rem; }\n\n.rz-job__feature-location {\n  font-size: 14px;\n  margin-top: 6px;\n  margin-bottom: 0; }\n\n.rz-job__feature-description {\n  font-size: 14px;\n  line-height: 1.2; }\n\n.rz__feature-button-container {\n  position: relative;\n  padding-top: 14px;\n  line-height: 1.5; }\n  .rz__feature-button-container:before, .rz__feature-button-container:after {\n    content: \" \";\n    display: table; }\n  .rz__feature-button-container:after {\n    clear: both; }\n\n.rz-job__feature-expiry {\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: -0.01rem; }\n\n.rz-community__card {\n  background-color: #fcf4ed;\n  padding: 35px 18px 37px 18px; }\n\n.rz-community__text-container {\n  padding-top: 8px;\n  text-align: left; }\n\n.rz-community__text-title {\n  font-size: 22px;\n  font-weight: bold;\n  margin-bottom: 5px; }\n\n.rz-community__text-description {\n  font-size: 18px;\n  line-height: 1.4;\n  color: #222222; }\n\n.rz-institute__course-duration {\n  font-size: 15px;\n  letter-spacing: -0.02rem; }\n\n.rz__label {\n  display: inline-block;\n  padding: 4px 6px;\n  line-height: 1;\n  text-transform: uppercase;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 2px;\n  color: #ffffff;\n  background-color: #5C656E; }\n\n.rz__label--resource {\n  background-color: #EF426F; }\n\n.rz__label--community {\n  background-color: #6376EC; }\n\n.rz__label--institute {\n  background-color: #002E5D; }\n\n.rz-rating {\n  display: inline-block;\n  position: relative;\n  padding-right: 5px; }\n\n.rz-rating__icon {\n  margin-right: 2px; }\n\n.rz-rating__count {\n  padding-left: 3px;\n  line-height: 1;\n  font-size: 0.70588rem;\n  color: inherit; }\n\n.rz-rating__stars {\n  display: inline-block;\n  position: relative;\n  z-index: 1; }\n\n.rz-rating__disabled-stars {\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: 0; }\n\n.rz-card {\n  position: relative;\n  line-height: 1;\n  background-color: #ffffff;\n  border: 1px solid #d2d6d9;\n  border-radius: 4px; }\n\n.rz-card__image-container {\n  padding-bottom: 68.6956521739%;\n  background-color: #F0F5FB;\n  overflow: hidden;\n  border-radius: 4px 4px 0 0; }\n\n.rz-card__image-container--small {\n  padding-bottom: 46.5217391304%; }\n\n.rz-card__body {\n  min-height: 190px;\n  padding: 12px 16px;\n  color: #222222;\n  border-radius: inherit; }\n\n.rz-card__body--sm {\n  min-height: 140px; }\n\n.rz-card__body--no-border,\n.rz-card__image-container {\n  margin: -1px; }\n\n.rz-card__body--no-bottom-radius,\n.rz-card__image-container {\n  border-radius: 4px 4px 0 0; }\n\n.rz-card__headline {\n  margin-top: 0;\n  margin-bottom: 5px;\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 1.11;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center; }\n\n.rz-card__headline--lg {\n  line-height: 1.1;\n  font-size: 22px; }\n\n.rz-card__description {\n  margin: 0 0 5px 0;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.45; }\n\n.rz-card__author {\n  margin: 0;\n  padding: 0;\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: -0.02rem; }\n\n.rz-card__footer {\n  position: relative;\n  padding: 13px 10px;\n  font-size: 14px;\n  line-height: 1;\n  display: -ms-flexbox;\n  display: flex; }\n\n.rz-card__rating {\n  margin-top: -5px;\n  margin-bottom: 5px;\n  font-size: 14px; }\n\n.rz-card__prices {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  display: inline-block;\n  line-height: 1.1;\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: -0.02rem; }\n  @media screen and (min-width: 744px) {\n    .rz-card__prices {\n      font-size: 12px; } }\n\n.rz-card__price {\n  color: #647787; }\n\n.rz-card__price--strike {\n  text-decoration: line-through;\n  margin-right: 8px; }\n\n.rz-card__discount-price {\n  color: #fd7037; }\n\n.rz-card__save {\n  -ms-flex-item-align: end;\n      align-self: flex-end; }\n\n.rz-card__body--color-0 {\n  background-color: #00C7B1;\n  color: #ffffff; }\n\n.rz-card__body--color-1 {\n  background-color: #0095C8;\n  color: #ffffff; }\n\n.rz-card__body--color-2 {\n  background-color: #002E5D;\n  color: #ffffff; }\n\n.rz-card__body--color-3 {\n  background-color: #43526F;\n  color: #ffffff; }\n\n.rz-card__body--color-4 {\n  background-color: #005A70;\n  color: #ffffff; }\n\n.rz-save-for-later {\n  line-height: 1.1;\n  font-size: 14px;\n  color: #b3b8bd;\n  text-decoration: none; }\n  @media screen and (min-width: 744px) {\n    .rz-save-for-later {\n      font-size: 12px; } }\n  .rz-save-for-later:hover {\n    color: #5c656e;\n    text-decoration: none; }\n\n.rz-save-for-later__icon {\n  margin-top: -3px;\n  margin-left: 4px; }\n";

},{}],2:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],3:[function(require,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.0
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));


}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":4}],4:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],5:[function(require,module,exports){
module.exports = require('./src/superagent-promise-plugin');

},{"./src/superagent-promise-plugin":6}],6:[function(require,module,exports){
function endPromise(req) {
  var _Promise = superagentPromisePlugin.Promise || Promise;

  return new _Promise(function (resolve, reject) {
    req.end(function (err, res) {
      err = err || res.error;
      if (err) {
        err.response = res;
        reject(err);
      } else 
        resolve(res);
    });
  });
}

function then() {
  var promise = endPromise(this);
  return promise.then.apply(promise, arguments);
}

function _catch() {
  var promise = endPromise(this);
  return promise.catch.apply(promise, arguments);
}

/**
 * Adds req.then and req.catch methods
 * @param {Object} req
 * @return {Object} req
 */
function superagentPromisePlugin(req) {
  req.then = then;
  req['catch'] = _catch;
  return req;
}

/**
 * Patches superagent so that every request has req.then and req.catch methods
 * @param {Object} superagent
 * @return {Object} superagent
 */
superagentPromisePlugin.patch = function patch(superagent) {
  superagent.Request.prototype.then = then;
  superagent.Request.prototype['catch'] = _catch;
  return superagent;
};

/**
 * Override with a Promise implementation
 */
superagentPromisePlugin.Promise = null;

module.exports = superagentPromisePlugin;

},{}],7:[function(require,module,exports){
/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = require('component-emitter');
var RequestBase = require('./request-base');
var isObject = require('./is-object');
var isFunction = require('./is-function');
var ResponseBase = require('./response-base');
var shouldRetry = require('./should-retry');

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
      status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if(this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can substitute for options
    options = pass;
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    }
  }

  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + btoa(user + ':' + pass));
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
      
    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
    break;  
  }
  return this;
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  // console.log(this._retries, this._maxRetries)
  if (this._maxRetries && this._retries++ < this._maxRetries && shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if (isFunction(this._sort)) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._appendQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  }
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn){
  var req = request('DELETE', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

},{"./is-function":8,"./is-object":9,"./request-base":10,"./response-base":11,"./should-retry":12,"component-emitter":2}],8:[function(require,module,exports){
/**
 * Check if `fn` is a function.
 *
 * @param {Function} fn
 * @return {Boolean}
 * @api private
 */
var isObject = require('./is-object');

function isFunction(fn) {
  var tag = isObject(fn) ? Object.prototype.toString.call(fn) : '';
  return tag === '[object Function]';
}

module.exports = isFunction;

},{"./is-object":9}],9:[function(require,module,exports){
/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;

},{}],10:[function(require,module,exports){
/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = require('./is-object');

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, read, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  return this;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {
  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

RequestBase.prototype.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
}

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {

  // name should be either a string or an object.
  if (null === name ||  undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on){
  // This is browser-only functionality. Node side is no-op.
  if(on==undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};


/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};


/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
}

},{"./is-object":9}],11:[function(require,module,exports){

/**
 * Module dependencies.
 */

var utils = require('./utils');

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field){
    return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
};

},{"./utils":13}],12:[function(require,module,exports){
var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
module.exports = function shouldRetry(err, res) {
  if (err && err.code && ~ERROR_CODES.indexOf(err.code)) return true;
  if (res && res.status && res.status >= 500) return true;
  // Superagent timeout
  if (err && 'timeout' in err && err.code == 'ECONNABORTED') return true;
  if (err && 'crossDomain' in err) return true;
  return false;
};

},{}],13:[function(require,module,exports){

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, shouldStripCookie){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  if (shouldStripCookie) {
    delete header['cookie'];
  }
  return header;
};
},{}],14:[function(require,module,exports){
'use strict';

var shorten = function shorten(text, limit) {
  if (text && text.length > limit) {
    return text.substr(0, text.lastIndexOf(' ', limit)) + '...';
  }
  return text || '';
};

module.exports = { shorten: shorten };

},{}],15:[function(require,module,exports){
'use strict';

var metadataFields = ['jobCatCodes', 'subjects', 'workplaces', 'positions', 'years', 'tags', 'section', 'id'];
var asArray = function asArray(value) {
  return Array.isArray(value) ? value : [value];
};

var Metadata = function Metadata(rzWindow) {
  var tesPageMetadata = rzWindow.TES && rzWindow.TES.pageMetadata;

  var valuesFor = function valuesFor(field) {
    return tesPageMetadata && tesPageMetadata[field] ? asArray(tesPageMetadata[field]).map(function (value) {
      return field + '=' + encodeURIComponent(value);
    }) : [];
  };

  var metadataForUrls = metadataFields.map(function (field) {
    return valuesFor(field);
  });

  var flattenedAndJoined = metadataForUrls.reduce(function (accumulator, current) {
    if (current.length > 0) {
      return accumulator.concat(current);
    }
    return accumulator;
  }, []).join('&');

  var emit_mz_impression_event = function emit_mz_impression_event(metadata) {
    var mergedPageMetadata = metadata.reduce(function (acc, current) {
      if (current) {
        Object.keys(current).map(function (key) {
          return acc[key] = current[key];
        });
      }
      return acc;
    }, tesPageMetadata);

    rzWindow.TES.pageMetadata = mergedPageMetadata;
    rzWindow._mz.pageMetadata = mergedPageMetadata;
    rzWindow._mz.emit(rzWindow._mze.IMPRESSION);
  };

  return {
    flattenedAndJoined: flattenedAndJoined,
    emit_mz_impression_event: emit_mz_impression_event
  };
};

module.exports = Metadata;

},{}],16:[function(require,module,exports){
'use strict';

var superagent = require('superagent');
var superagentPromisePlugin = require('superagent-promise-plugin');

var get = function get(endpoint) {
  return superagent.get(endpoint).use(superagentPromisePlugin).withCredentials().timeout(2000).set({
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  });
};

var post = function post(endpoint, data) {
  return superagent.post(endpoint).use(superagentPromisePlugin).withCredentials().timeout(2000).set({
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }).send(data);
};

module.exports = { get: get, post: post };

},{"superagent":7,"superagent-promise-plugin":5}],17:[function(require,module,exports){
'use strict';

var liveSections = ['jobs'];

var includes = function includes(values, value) {
  return values.indexOf(value) > -1;
};

var Toggles = function Toggles(rzWindow, sectionName, node) {
  var rzToggles = rzWindow.Cookies && rzWindow.Cookies.get('rzToggles') || '';

  var isToggledOn = includes(liveSections, sectionName) || includes(rzToggles, sectionName);

  var toggledOff = function toggledOff() {
    node.innerHTML = '<!-- rz ' + sectionName + ' is toggled off -->';
    return {};
  };

  var ifToggled = function ifToggled(toggledOn) {
    return isToggledOn ? toggledOn() : toggledOff();
  };

  return {
    ifToggled: ifToggled
  };
};

module.exports = Toggles;

},{}],18:[function(require,module,exports){
'use strict';

var Rz = require('./rz');

var w = window ? window : {};
var d = document ? document : {};

w.TES = w.TES || {};
w.TES.rz = new Rz(w, d);
w._rz = w.TES.rz;

},{"./rz":19}],19:[function(require,module,exports){
'use strict';

var _es6Promise = require('es6-promise');

var _sections = require('./sections');

var _sections2 = _interopRequireDefault(_sections);

var _toggles = require('./lib/toggles');

var _toggles2 = _interopRequireDefault(_toggles);

var _metadata = require('./lib/metadata');

var _metadata2 = _interopRequireDefault(_metadata);

var _request = require('./lib/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Rz(rzWindow, rzDocument) {
  var _ref = new _metadata2.default(rzWindow),
      flattenedAndJoined = _ref.flattenedAndJoined,
      emit_mz_impression_event = _ref.emit_mz_impression_event;

  var rz_nodes = [].slice.call(rzDocument.querySelectorAll('[data-rz]'));

  return _es6Promise.Promise.all(rz_nodes.map(function (node) {
    var sectionName = node.getAttribute('data-rz');

    var _ref2 = new _toggles2.default(rzWindow, sectionName, node),
        ifToggled = _ref2.ifToggled;

    var emit_event = function emit_event(status, error, url, recover) {
      return rzWindow.TES._rz_listeners && rzWindow.TES._rz_listeners.forEach(function (listener) {
        return listener({
          sectionName: sectionName,
          status: status,
          error: error,
          url: url,
          recover: recover
        });
      });
    };

    var section = _sections2.default[sectionName];

    if (!section) {
      emit_event('ERROR', 'unknown section');
      return {};
    }

    return ifToggled(function () {
      var url = section.endpoint + '?' + flattenedAndJoined;

      return (0, _request.get)(url).then(function (response) {
        if (!response.body.results || response.body.results.length === 0) {
          emit_event('ERROR', 'no results', url, function (html) {
            return node.innerHTML = html;
          });
          return {};
        }

        var renderOutput = section.render(response.body.results);
        node.innerHTML = renderOutput.html;

        if (section.registerListeners) {
          section.registerListeners(rzWindow, rzDocument);
        }

        emit_event('SUCCESS');
        return renderOutput.metadata;
      }).catch(function (err) {
        emit_event('ERROR', err.status, url, function (html) {
          return node.innerHTML = html;
        });
        return {};
      });
    });
  })).then(function (values) {
    var valuesWithKeys = values.filter(function (v) {
      return Object.keys(v).length > 0;
    });
    if (valuesWithKeys.length > 0) {
      emit_mz_impression_event(values);
    }
    return null;
  });
}

module.exports = Rz;

},{"./lib/metadata":15,"./lib/request":16,"./lib/toggles":17,"./sections":21,"es6-promise":3}],20:[function(require,module,exports){
'use strict';

var _styles = require('../../dist/styles.js');

var community = {
  endpoint: '/api/rz/community',
  render: function render(results) {
    var recommendedCommunityUrls = [];
    var item = results[0];
    var output = '';

    if (item) {
      recommendedCommunityUrls.push(item.url);
      output = '\n        <div class="rz"><a class="link--unstyled" href="' + item.url + '">\n\n          <div class="rz-community__card">\n            <div class="rz__label rz__label--community">community forum</div>\n            <div class="rz-community__text-container"></div>\n            <div class="rz-community__text-title">' + item.title + '</div>\n            <div class="rz-communit__text-description">' + item.description + '</div>\n          </div>\n         </a>\n        </div>';
    }

    var html = '\n      <style>' + _styles.styles + '</style>\n      <div class="rz">' + output + '</div>';
    return {
      html: html,
      metadata: {
        recommendedCommunityUrls: recommendedCommunityUrls
      }
    };
  }
};

module.exports = community;

},{"../../dist/styles.js":1}],21:[function(require,module,exports){
'use strict';

var _community = require('./community');

var _community2 = _interopRequireDefault(_community);

var _institute = require('./institute');

var _institute2 = _interopRequireDefault(_institute);

var _jobs = require('./jobs');

var _jobs2 = _interopRequireDefault(_jobs);

var _rebrandJobs = require('./rebrandJobs');

var _rebrandJobs2 = _interopRequireDefault(_rebrandJobs);

var _news = require('./news');

var _news2 = _interopRequireDefault(_news);

var _resources = require('./resources');

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sections = {
  community: _community2.default,
  institute: _institute2.default,
  jobs: _jobs2.default,
  rebrandJobs: _rebrandJobs2.default,
  news: _news2.default,
  resources: _resources2.default
};

module.exports = sections;

},{"./community":20,"./institute":22,"./jobs":23,"./news":24,"./rebrandJobs":25,"./resources":26}],22:[function(require,module,exports){
'use strict';

var _styles = require('../../dist/styles.js');

var _helpers = require('../lib/helpers');

var institute = {
  endpoint: '/api/rz/institute',
  render: function render(course) {
    var courseOutput = '';
    var recommendedInstituteUrls = [];

    if (course) {
      recommendedInstituteUrls.push(course.url);

      var bannerDiv = course.image.src ? '<div class="rz-card__image-container rz-card__image-container--small responsive-image">\n           <img class="responsive-image__inner responsive-image__inner--height-auto" src="' + course.image.src + '" srcset="' + course.image.src + ' 2x"/>\n         </div>' : '';
      course.shortDescription = (0, _helpers.shorten)(course.description, 111);

      courseOutput = '\n        <div class="rz-card">\n          ' + bannerDiv + '\n          <div class="rz-card__body rz-card__body--no-border">\n            <div class="rz__label rz__label--institute">\n              featured course\n            </div>\n            <div class="padding-top-bottom-sm">\n              <h4 class="rz-card__headline rz-card__headline--lg">' + course.title + '</h4>\n              <p class="rz-card__description">' + course.shortDescription + '&nbsp;\n                <a class="link link--colored" href="' + course.url + '">More</a>\n              </p>\n            </div>\n            <div class="rz__feature-button-container border-top">\n              <span class="rz-institute__course-duration">\n                 <i class="icon-clock-o icon-gray"></i>\n                 <span class="text text--discreet">' + course.course_length + '</span>\n              </span>\n              <a href="' + course.url + '" class="tes-btn tes-btn--sm tes-btn--secondary pull-right">View Course</a>\n            </div>\n          </div>\n        </div>\n        ';
    }

    var html = '\n      <style>' + _styles.styles + '</style>\n      <div>' + courseOutput + '</div>\n      ';

    return {
      html: html,
      metadata: {
        recommendedInstituteUrls: recommendedInstituteUrls
      }
    };
  }
};

module.exports = institute;

},{"../../dist/styles.js":1,"../lib/helpers":14}],23:[function(require,module,exports){
'use strict';

var _styles = require('../../dist/styles.js');

var _helpers = require('../lib/helpers');

var jobs = {
  endpoint: '/api/rz/jobs',
  render: function render(results) {
    var spotlightExclusiveJobIds = [];
    var spotlightJobIds = [];

    var items = [];
    for (var position = 1; position <= results.length; position++) {
      var item = results[position - 1];
      if (item) {
        var subheading = item.organisation && item.location ? item.organisation + ', ' + item.location : item.organisation || item.location || '';
        var logoDiv = item.logo ? '<div class="image-card__img-wrapper-inner image-card__img-wrapper-inner--4x3 image-card__img-wrapper-inner--highlighted image-card__img-wrapper-inner--no-border"><img class="l-pos-center" width="80" height="40" src="' + item.logo + '"></div>' : '';
        if (item.type === 'exclusive') {
          spotlightExclusiveJobIds.push(item.jobId);
          item.shortDescription = (0, _helpers.shorten)(item.description, 75);

          var applyBy = item.applyBy ? 'Apply by ' + item.applyBy : '';
          var bannerDiv = item.banner ? '<div class="rz-exclusive-banner"><img src="' + item.banner + '" srcset="' + item.banner2x + ' 2x" width="100%"/></div>' : '<div class="rz-exclusive-banner rz-exclusive-banner__empty"></div>';
          items.push('\n          <li class="rz-item rz-item--exclusive" data-position="' + position + '">\n            <a data-mz="true" data-module="job-exclusive" data-id="' + item.promoId + '" href="' + item.url + '" class="image-card">\n              <div class="rz-exclusive-container">\n                ' + bannerDiv + '\n                <div class="rz-exclusive-container__content">\n                  <div class="image-card__img-wrapper image-card__img-wrapper--xs image-card__image-wrapper--shift-up">\n                    ' + logoDiv + '\n                  </div>\n                  <div class="image-card__text image-card__text--top image-card__text--left image-card__text--full-width">\n                    <h4 class="heading heading--semi-bold margin-bottom-xxs">' + item.title + '</h4>\n                    <p class="text text--xs margin-bottom-none">' + subheading + '</p>\n                    <p class="text text--xs margin-top-bottom-sm t-rz-description" title="' + item.description + '">' + item.shortDescription + '</p>\n                  </div>\n                  <div class="rz-exclusive-footer">\n                    <div class="rz-list__left">\n                      <span class="text--xxs rz-highlight-orange">' + applyBy + '</span>\n                    </div>\n                    <div class="rz-list__right">\n                      <span class="tes-btn tes-btn--xs tes-btn--block tes-btn--secondary">View job</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </a>\n          </li>\n          ');
        } else {
          spotlightJobIds.push(item.jobId);
          items.push('\n          <li class="rz-item" data-position="' + position + '">\n            <a data-mz="true" data-module="job-' + item.type + '" data-id="' + item.promoId + '" href="' + item.url + '" class="image-card">\n              <div class="image-card__text image-card__text--top image-card__text--left image-card__text--xs">\n                <h4 class="heading heading--sm heading--semi-bold margin-bottom-xxs">' + item.title + '</h4>\n                <p class="text text--xs margin-bottom-none">' + subheading + '</p>\n              </div>\n              <div class="image-card__img-wrapper image-card__img-wrapper--xs">\n                ' + logoDiv + '\n              </div>\n            </a>\n          </li>\n          ');
        }
      }
    }
    var singleExclusiveClass = results.length === 1 && results[0].type === 'exclusive' ? 'padding-bottom-none' : '';
    var html = '\n      <style>' + _styles.styles + '</style>\n      <div class="tes-panel tes-panel--highlighted ' + singleExclusiveClass + '">\n        <div class="tes-panel__body--sm">\n          <h3 class="heading heading--lg heading--semi-bold margin-bottom-sm">Recommended jobs</h3>\n          <ul class="list-unstyled">\n            ' + items.join('') + '\n          </ul>\n        </div>\n      </div>\n      ';
    return {
      html: html,
      metadata: {
        spotlightExclusiveJobIds: spotlightExclusiveJobIds,
        spotlightJobIds: spotlightJobIds
      }
    };
  }
};

module.exports = jobs;

},{"../../dist/styles.js":1,"../lib/helpers":14}],24:[function(require,module,exports){
'use strict';

var _styles = require('../../dist/styles.js');

var _helpers = require('../lib/helpers');

var news = {
  endpoint: '/api/rz/news',
  render: function render(results) {
    var limit = 5;
    var items = [];
    var recommendedNewsUrls = [];

    for (var position = 1; position <= limit; position++) {
      var item = results[position - 1];

      if (item) {
        var logoDiv = item.image2 ? '<img class="responsive-image__inner responsive-image__inner--height-auto" src="' + item.image2 + '"/>' : '';

        item.shortTitle = (0, _helpers.shorten)(item.title, 80);

        recommendedNewsUrls.push(item.path);

        items.push('\n        <li data-position="' + position + '">\n          <a class="link--unstyled rz-list__item" data-mz="true" data-module="news-contextual" data-id="' + item.path + '" href="' + item.path + '">\n            <div class="rz__text-container">\n              <h4 class="rz-list__item-title l-inline">' + item.shortTitle + '.</h4>\n              <p class="rz-list__item-text l-inline">This is the most amazing news that a teacher can possibly get...</p>\n            </div>\n            <div class="rz-image-container">\n              ' + logoDiv + '\n            </div>\n          </a>\n        </li>\n        ');
      }
    }

    var html = '\n      <style>' + _styles.styles + '</style>\n      <div class="rz">\n        <h3 class="rz__title rz__title--pink">Latest news</h3>\n        <ul class="rz-list list-unstyled">\n          ' + items.join('') + '\n        </ul>\n        <a class="rz__more-link link link--colored" href="#newLink">More news</a>\n      </div>\n      ';
    return {
      html: html,
      metadata: {
        recommendedNewsUrls: recommendedNewsUrls
      }
    };
  }
};

module.exports = news;

},{"../../dist/styles.js":1,"../lib/helpers":14}],25:[function(require,module,exports){
'use strict';

var _styles = require('../../dist/styles.js');

var _helpers = require('../lib/helpers');

var jobs = {
  endpoint: '/api/rz/jobs',
  render: function render(results) {
    var spotlightExclusiveJobIds = [];
    var spotlightJobIds = [];

    var items = [];
    var featureItem = [];
    for (var position = 1; position <= results.length; position++) {
      var item = results[position - 1];
      if (item) {
        var subheading = item.organisation && item.location ? item.organisation + ', ' + item.location : item.organisation || item.location || '';
        var logoDiv = item.logo ? '<img class="responsive-image__inner responsive-image__inner--height-auto" src="' + item.logo + '"/>' : '';
        if (item.type === 'exclusive') {
          spotlightExclusiveJobIds.push(item.jobId);
          item.shortDescription = (0, _helpers.shorten)(item.description, 75);

          var applyBy = item.applyBy ? 'Closing date ' + item.applyBy : '';
          var bannerDiv = item.banner ? '<div class="rz-job__img-container responsive-image"><img class="responsive-image__inner" src="' + item.banner + '" srcset="' + item.banner2x + ' 2x"/></div>' : '<div class="rz-exclusive-banner rz-exclusive-banner__empty"></div>';
          featureItem.push('\n          <div class="rz-job">\n              ' + bannerDiv + '\n           <a class="link--unstyled" data-mz="true" data-module="job-exclusive" data-id="' + item.promoId + '" href="' + item.url + '">\n            <div class="rz-job__body">\n              <div class="rz-job__feature">\n                <div class="rz__text-container">\n                  <h2 class="rz-job__feature-title">' + item.title + '</h2>\n                  <p class="rz-job__feature-location text--discreet">' + item.location + '</p>\n                </div>\n                <div class="rz-image-container">\n                  ' + logoDiv + '\n                </div>\n              </div>\n              <div class="rz-job__feature-description">' + item.shortDescription + '</div>\n              <div class="rz__feature-button-container">\n                <span class="rz-job__feature-expiry">' + applyBy + '</span>\n                <button class="tes-btn tes-btn--sm tes-btn--secondary pull-right">View job</button>\n              </div>\n             </div>\n            </a>\n          </div>\n\n      ');
        } else {
          spotlightJobIds.push(item.jobId);
          items.push('\n          <li data-position="' + position + '">\n            <a\n              class="link--unstyled rz-list__item"\n              data-mz="true"\n              data-module="job-' + item.type + '"\n              data-id="' + item.promoId + '"\n              href="' + item.url + '"\n            >\n              <div class="rz__text-container">\n                <h4 class="rz-list__item-title l-inline">' + item.title + '</h4>\n                <p class="rz-list__item-text l-inline">' + subheading + '</p>\n              </div>\n              <div class="rz-image-container">\n                ' + logoDiv + '\n              </div>\n            </a>\n          </li>\n          ');
        }
      }
    }
    var html = '\n      <style>' + _styles.styles + '</style>\n      <div class="rz">\n        <h3 class="rz__title rz__title--mint">Jobs for you</h3>\n          ' + featureItem[0] + '\n        <ul class="rz-list list-unstyled">\n          ' + items.join('') + '\n        </ul>\n        <a class="rz__more-link link link--colored" href="#newLink">More jobs</a>\n      </div>\n      ';
    return {
      html: html,
      metadata: {
        spotlightExclusiveJobIds: spotlightExclusiveJobIds,
        spotlightJobIds: spotlightJobIds
      }
    };
  }
};

module.exports = jobs;

},{"../../dist/styles.js":1,"../lib/helpers":14}],26:[function(require,module,exports){
'use strict';

var _styles = require('../../dist/styles.js');

var _helpers = require('../lib/helpers');

var _request = require('../lib/request');

var saveStates = {
  SAVE: 'Save',
  SAVING: 'Saving',
  SAVED: 'Saved'
};

var saveHandler = function saveHandler(el, rzWindow) {
  return function () {
    var isLoggedIn = !!rzWindow.Cookies.get('TESCookieUser');
    var resourceId = el.getAttribute('data-rz-resource');
    var spans = el.getElementsByTagName('span');
    var saveSpan = spans && spans.length > 0 && spans[0];
    var saveIcon = el.getElementsByTagName('i')[0];

    var save = function save() {
      if (saveSpan.innerHTML !== saveStates.SAVE) {
        return;
      }
      saveSpan.innerHTML = saveStates.SAVING;
      (0, _request.post)('/api/favourites/v1', { applicationId: resourceId }).then(function (response) {
        if (response.status === 200 && response.body && response.body.isFavourite) {
          saveSpan.innerHTML = saveStates.SAVED;
          saveIcon.setAttribute('class', 'icon-bookmark icon-xs icon-mint');
        } else {
          saveSpan.innerHTML = saveStates.SAVE;
        }
      }).catch(function () {
        saveSpan.innerHTML = saveStates.SAVE;
      });
    };

    if (isLoggedIn) {
      save();
    } else {
      var events = rzWindow.TES && rzWindow.TES.events;
      events.trigger('auth-open', 'sign-in', false);
      events.on('logged-in', function () {
        save();
      });
    }
  };
};

var resources = {
  endpoint: '/api/rz/resources',
  registerListeners: function registerListeners(rzWindow, rzDocument) {
    var saveElements = rzDocument.querySelectorAll('[data-rz-event-emitter]');
    for (var i = 0; i < saveElements.length; i++) {
      var element = saveElements[i];
      element.onclick = saveHandler(element, rzWindow);
    }
  },
  render: function render(results) {
    var getStars = function getStars(rating) {
      var stars = [];

      for (var star = 0; star < 5; star++) {
        var remaining = rating - star;
        if (remaining >= 1) {
          stars.push('<i class="rating__icon icon-star icon-white icon-xs"></i>');
        } else if (remaining > 0) {
          stars.push('<i class="rating__icon icon-star-half icon-white icon-xs"></i>');
        } else {
          stars.push('<i class="rating__icon icon-star icon-white icon-alpha-50 icon-xs"></i>');
        }
      }
      return stars;
    };

    var opaqueStars = '\n          <i class="rating__icon icon-star icon-white icon-alpha-50 icon-xs"></i>\n          <i class="rating__icon icon-star icon-white icon-alpha-50 icon-xs"></i>\n          <i class="rating__icon icon-star icon-white icon-alpha-50 icon-xs"></i>\n          <i class="rating__icon icon-star icon-white icon-alpha-50 icon-xs"></i>\n          <i class="rating__icon icon-star icon-white icon-alpha-50 icon-xs"></i>\n         ';

    var limit = 5;
    var items = [];
    var recommendedResourceIds = [];

    var theme = Math.floor(Math.random() * limit);

    for (var position = 1; position <= limit; position++) {
      var item = results[position - 1];

      if (item) {
        recommendedResourceIds.push(item.resourceId);
        item.shortDescription = (0, _helpers.shorten)(item.description, 75);
        var discountedPrice = item.discountedPrice || '';
        var cardPriceCssClass = discountedPrice ? 'rz-card__price rz-card__price--strike' : 'rz-card__price';
        var iconClasses = 'icon-bookmark icon-xs icon-light-gray';
        var saveText = 'Save';
        items.push('\n          <div class="padding-bottom-md">\n            <li class="rz-card" data-position="' + position + '">\n              <a href="' + item.url + '" class="link link--inherit-color link--nounderline">\n                <div class="rz-card__body rz-card__body--sm rz-card__body--no-border rz-card__body--no-bottom-radius rz-card__body--color-' + theme + '">\n                  <h4 class="rz-card__headline inherit-color">' + item.title + '</h4>\n                  <p class="rz-card__description inherit-color">' + item.shortDescription + '</p>\n                  <div class="rz-card__rating">\n                    <span class="rz-rating">\n                      <span class="rz-rating__stars">\n                        ' + getStars(item.ratingAverage).join(' ') + '\n                      </span>\n                      <span class="rz-rating__disabled-stars">\n                        ' + opaqueStars + '\n                      </span>\n                      <span class="text--xs">(' + item.ratingCount + ')</span>\n                    </span>\n                  </div>\n                  <p class="rz-card__author">' + item.authorName + '</p>\n                </div>\n              </a>\n              <div class="rz-card__footer">\n                <div class="rz-card__prices">\n                  <span class="' + cardPriceCssClass + '">' + item.price + '</span>\n                  <span class="rz-card__discount-price">' + discountedPrice + '</span>\n                </div>\n                <div class="rz-card__save">\n                  <a class="rz-save-for-later" href="javascript: void(0);" data-rz-event-emitter data-rz-resource="' + item.resourceId + '">\n                    <span class="rz-save-for-later__text">' + saveText + '</span>\n                    <span class="rz-save-for-later__icon">\n                      <i class="' + iconClasses + '"></i>\n                    </span>\n                  </a>\n                </div>\n              </div>\n            </li>\n          </div>\n          ');

        if (++theme > 4) {
          theme = 0;
        }
      }
    }
    var html = '\n      <style>' + _styles.styles + '</style>\n      <div class="rz">\n          <h3 class="rz__title">Recommended Resources</h3>\n          <ul class="rz-list rz-list--resources list-unstyled">\n            ' + items.join('') + '\n          </ul>\n      </div>\n      ';
    return {
      html: html,
      metadata: {
        recommendedResourceIds: recommendedResourceIds
      }
    };
  }
};

module.exports = resources;

},{"../../dist/styles.js":1,"../lib/helpers":14,"../lib/request":16}]},{},[18]);
